import './App.css';
import FullPage from './components/fullPage/fullPage';

function App() {
	return (
		<div className="App">
			<FullPage />
		</div>
	);
}

export default App;
